import { SortIcon } from "components/Table_SortColumnIcon"
import { getFormattedTime } from "utils"

const referFriendListColumns = () => {
  return [
    {
      text: "id",
      dataField: "id",
      sort: true,
      hidden: true,
      formatter: (cellContent, item) => <>{item?.id}</>,
    },
    {
      text: "Referrer's Name",
      dataField: "from_name",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => <>{item?.from_name}</>,
    },
    {
      text: "Referrer's Email",
      dataField: "from_email",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => <>{item.from_email}</>,
    },
    {
      text: "Friend's name",
      dataField: "to_name",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => <>{item.to_name}</>,
    },
    {
      text: "Friend's Email",
      dataField: "to_email",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => <>{item.to_email}</>,
    },
    {
      text: "Friend's Phone",
      dataField: "to_phone",
      formatter: (cellContent, item) => <>{item.to_phone}</>,
    },
    {
      text: "Date/Time Referred",
      dataField: "created_at",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => (
        <>
          <>{item?.created_at ? getFormattedTime(item?.created_at) : "-"}</>
        </>
      ),
    },
  ]
}

export default referFriendListColumns
